import { Builder } from "@builder.io/react";
import TrustPilotReviews from "./TrustPilotReviews";

Builder.registerComponent(TrustPilotReviews, {
  name: "TrustPilotReviews",
  inputs: [],
});
